import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import SvgIcon from '../presentation/SvgIcon';
import LogoIcon from '../assets/images/svgs/chatera-logo.svg';
import actions from '../actions';
import { isObjectEmpty, autobind } from '../utils';

@connect((state) => {
    return {
        signIn: state.userAccount.signIn
    }
})
export default class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: {
                username: "",
                password: ""
            },
            validationErrors: {}
        }
        autobind(['handleChange', 'validateField', 'login'], this);
    }

    login() {
        const user = this.state.user;
        const validationErrors = this.state.validationErrors;
        if(!isObjectEmpty(validationErrors)) {
            this.setState({errorMessage: "Please correct the above errors before proceeding."});
            return;
        }
        if(!user.username || !user.password) {
            this.setState({errorMessage: "Please enter email and password before proceeding."});
            return;
        }
        this.setState({ errorMessage: undefined });
        this.props.dispatch({
            type: actions.SIGNIN_REQUEST,
            user: this.state.user
        });
    }

    handleChange(field, value) {
        const user = Object.assign({}, this.state.user, {
            [field]: value
        });
        this.setState({user});
    }

    validateField(field) {
        let fieldValue = this.state.user[field];
        const validationErrors = this.state.validationErrors;
        switch(field) {
            case "username":
                const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(!fieldValue || !emailRegex.test(fieldValue)) {
                    validationErrors[field] = "Please enter a valid email address";
                    this.setState({validationErrors});
                    return;
                }
                break;
            case "password":
                if(!fieldValue || fieldValue.length < 3 || fieldValue.length > 25) {
                    validationErrors[field] = "Please enter a valid response with min. 3 and max. 25 characters";
                    this.setState({validationErrors});
                    return;
                }
                break;
            default:
                break;
        }
        delete validationErrors[field];
        this.setState({validationErrors});
    }



    render() {
        const validationErrors = this.state.validationErrors;
        const signInState = this.props.signIn;
        return (
            <div className="login-screen-container hflex">
                <div className="login-content">
                    <Link to="/" className="logo hflex">
                        {/*<img className="logo-image" src={require('../assets/images/pngs/logo.png')} />*/}
                        <SvgIcon className="logo-image" glyph={LogoIcon} width='185px' height='26px'/>
                    </Link>
                    <div className="title-container">
                        <p className="subtitle">Please enter your credentials below to continue</p>
                    </div>
                    <form className="login-form">
                        <div className={validationErrors.username ? "input-container invalid" : "input-container"}>
                            <input type="email" placeholder="Email" value={user.username} className="input-field" onBlur={this.validateField.bind(this, "username")} onChange={(event) => this.handleChange("username", event.target.value)} />
                            {validationErrors.username && <p className="input-validation-error">{validationErrors.username}</p>}
                        </div>
                        <div className={validationErrors.password ? "input-container invalid" : "input-container"}>
                            <input type="password" placeholder="Password" value={user.password} className="input-field" onBlur={this.validateField.bind(this, "password")} onChange={(event) => this.handleChange("password", event.target.value)} />
                            {validationErrors.password && <p className="input-validation-error">{validationErrors.password}</p>}
                        </div>
                    </form>
                    {this.state.errorMessage && <p className="form-error-message">{this.state.errorMessage}</p>}
                    {signInState.signInFailed && <p className="form-error-message">{signInState.statusText}</p>}
                    <div className="actions-container hflex">
                        <button type="button" className="action-btn btn btn-primary" onClick={this.login}>Login</button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Login.js